export const pagesPayrollEngineEn = {
  atomDetail: {
    applyDialog: {
      cancel: 'Cancel',
      confirm: 'Apply',
      description:
        'Moves the record from draft to applied. The mock skips process-definition selection (production follows design §4.0).',
      title: 'Apply this master?',
    },
    applyError: 'Could not apply',
    applySuccess: 'Applied',
    deleteDialog: {
      blockedByUsage:
        'In use by a pay or bonus structure and cannot be deleted.',
      cancel: 'Cancel',
      confirm: 'Delete',
      description:
        'This cannot be undone. Remove it from pay and bonus structure composition first if it is in use.',
      title: 'Delete this master?',
    },
    deleteError: 'Could not delete',
    deleteSuccess: 'Deleted',
    documentTitleFallback: 'Master detail',
    documentTitleSuffix: 'Payroll Engine',
    editDialog: {
      cancel: 'Cancel',
      save: 'Save',
      title: 'Edit master',
    },
    enums: {
      bool: {
        false: 'No',
        true: 'Yes',
      },
      category: {
        company: 'Company',
        statutory: 'Statutory',
      },
      taxability: {
        'conditionally-taxable': 'Conditionally taxable',
        'non-taxable': 'Non-taxable',
        'partially-taxable': 'Partially taxable',
        taxable: 'Taxable',
      },
      type: {
        deduction: 'Deduction',
        earning: 'Earning',
      },
      variability: {
        fixed: 'Fixed',
        variable: 'Variable',
      },
    },
    errors: {
      invalidConfigJson: 'Must be valid JSON',
    },
    fields: {
      category: 'Category',
      countryCode: 'Country code',
      createdAt: 'Created at',
      createdBy: 'Created by',
      description: 'Description',
      isDefault: 'Legal default',
      lifecycleStatus: 'Status',
      managementName: 'Management name',
      name: 'Name',
      nameEn: 'English name',
      no: 'No.',
      paySlipDisplayName: 'Pay slip display name',
      paySlipOrder: 'Pay slip display order',
      retroactive: 'Retroactive',
      taxability: 'Taxability',
      type: 'Type',
      updatedAt: 'Updated at',
      validFrom: 'Valid from',
      validTo: 'Valid to (leave empty for open-ended)',
      variability: 'Variability',
    },
    header: {
      apply: 'Apply',
      delete: 'Delete',
      edit: 'Edit',
      retire: 'Archive',
    },
    lifecycle: {
      applied: 'Active',
      archived: 'Archived',
      draft: 'Draft',
    },
    retireDialog: {
      cancel: 'Cancel',
      confirm: 'Archive',
      description:
        'Moves the record from applied to archived. Check downstream pay/bonus structures if still referencing it.',
      title: 'Archive this master?',
    },
    retireError: 'Could not archive',
    retireSuccess: 'Archived',
    saveError: 'Could not save',
    saveSuccess: 'Saved',
    sections: {
      audit: 'Audit',
      basic: 'Basic information',
      logic: 'Logic',
      peopleCondition: 'People condition (People Group)',
      peopleConditionHint:
        'Optional peopleGroupIds live in config JSON. Edit them in the rule body above.',
      ruleBody: 'Rule body (config)',
      ruleBodyHint:
        'Stored as JSON. Omit peopleGroupIds or use an empty array when this component has no People Group scope (design §5.6).',
      usage: 'Where used',
    },
    usage: {
      columns: {
        name: 'Name',
        type: 'Type',
      },
      empty: 'Not referenced by any pay structure.',
      payrollStructures: 'Pay structures',
    },
    view: {
      openEndedValidTo: '— (open-ended)',
    },
  },
  atomList: {
    addRecordLabels: {
      pay_structure: 'Add payroll structure',
      pay_unit: 'Add payroll unit',
      payroll_item: 'Add payroll item',
      payroll_logic_component: 'Add payroll logic component',
    },
    columns: {
      country: 'Country',
      description: 'Description',
      name: 'Name',
      type: 'Type',
      validFrom: 'Valid From',
    },
    createRecordToastDescription:
      'Creating records from this list will be available when the create flow is implemented.',
    createRecordToastTitle: 'Not available yet',
    filters: {
      allCountries: 'All Countries',
      countryChip: 'Country',
      global: 'Global',
      jp: 'Japan',
      sg: 'Singapore',
    },
    lifecycleTabs: {
      all: 'All',
      applied: 'Active',
      archived: 'Archived',
      draft: 'Draft',
    },
  },
  components: {
    categories: {
      calculation_logic: 'Calculation Logic',
      deduction_item: 'Deduction Item',
      earning_item: 'Earning Item',
      payment_cycle: 'Payment Cycle',
      proration_method: 'Proration Method',
      rounding_rule: 'Rounding Rule',
      social_insurance: 'Social Insurance',
    },
    filters: {
      allCategories: 'All Categories',
      allCountries: 'All Countries',
    },
    title: 'Components',
    types: {
      custom: 'Custom',
      default: 'Legal Default',
    },
  },
  itemsList: {
    columns: {
      badge: 'Badge',
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
      no: 'No.',
    },
    empty: 'No payroll items yet.',
  },
  logicComponentsList: {
    columns: {
      badge: 'Badge',
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
    },
    empty: 'No payroll logic components yet.',
  },
  pageTitle: 'Payroll Engine',
  payrollStructures: {
    noPayrollStructures: 'No pay structures registered',
    title: 'Pay Structures',
  },
  payrollStructuresList: {
    columns: {
      country: 'Country',
      description: 'Description',
      name: 'Name',
      nameEn: 'English name',
      type: 'Type',
      updatedAt: 'Updated',
    },
  },
  payrollUnitsList: {
    columns: {
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
      no: 'No.',
    },
    empty: 'No payroll units yet.',
  },
  structureDetail: {
    composition: {
      empty: 'No engine components are linked.',
      kind: {
        item: 'Item',
        logic_component: 'Logic Component',
      },
      missingRow: 'Component record not found.',
      openAtom: 'Open master detail',
      sameAsPaymentCycleNote: 'Same as the payment cycle above.',
      sectionTitle: 'Components (ordered)',
    },
    deleteDialog: {
      cancel: 'Cancel',
      confirm: 'Delete',
      description:
        'This cannot be undone. Check payroll assignments and downstream references first.',
      title: 'Delete this pay structure?',
    },
    documentTitleFallback: 'Structure detail',
    documentTitleSuffix: 'Payroll Engine',
    dynamics: {
      emptyComposition:
        'No composition steps are linked. The payment cycle node is shown when assigned.',
    },
    dynamicsV2: {
      simulationToolbar: {
        removePerson: 'Remove',
        runSimulation: 'Run simulation',
        selectPersonLabel: 'Simulation subject',
        selectPersonPlaceholder: 'Select a person',
        simulationToastDescription:
          '{{count}} person(s) included (preview only).',
        simulationToastNoPeople:
          'Select at least one person before running the simulation.',
        simulationToastTitle: 'Simulation finished',
      },
      stagePill: 'Stage {{index}}',
    },
    editDialog: {
      cancel: 'Cancel',
      fields: {
        countryCode: 'Country code',
        description: 'Description',
        isDefault: 'Legal default',
        name: 'Name',
        nameEn: 'English name',
      },
      save: 'Save',
      saveError: 'Could not save',
      saveSuccess: 'Saved',
      title: 'Edit structure',
    },
    fields: {
      countryCode: 'Country code',
      createdAt: 'Created at',
      createdBy: 'Created by',
      description: 'Description',
      isDefault: 'Legal default',
      lifecycleStatus: 'Status',
      name: 'Name',
      nameEn: 'English name',
      updatedAt: 'Updated at',
    },
    mock: {
      card: { detail: 'Detail' },
      empty: 'No payroll unit is selected.',
      loading: 'Loading…',
      openUnitDetail: 'Open unit detail page',
      section: {
        input: 'INPUT',
        output: 'OUTPUT',
        process: 'PROCESS',
      },
      sidebar: {
        categories: {
          attendanceFinalize: 'Attendance close & external data import',
          memberRefresh: 'Member data refresh',
          payment: 'Payment execution',
          payrollCalc: 'Payroll calculation',
          statutory: 'Statutory filing & accounting',
        },
        close: 'Close side tab',
      },
      toolbar: {
        dryRun: 'Dry run:',
        run: 'Run',
        viewList: 'List',
        viewTree: 'Tree',
      },
    },
    paymentCycle: {
      cardTitle: 'Assigned payment cycle',
      missing: 'Payment cycle master was not found.',
    },
    sections: {
      audit: 'Audit',
      basic: 'Basic information',
      composition: 'Composition',
      paymentCycle: 'Payment cycle',
    },
    structure: {
      badges: {
        deduction: 'Deduction',
        earning: 'Earning',
        total: 'Total',
      },
      demoCaption:
        'Illustrative process flow (design reference). Live composition mapping will replace this preview when the engine exposes process units.',
      demoFootnote:
        'Unit labels are English examples only; they are not read from your structure data yet.',
      logicKinds: {
        arithmetic: 'Arithmetic',
        multiply: 'Multiply',
        subtract: 'Subtract',
        sum: 'Sum',
        tableLookup: 'Table Lookup',
      },
      segmentInput: 'Input',
      segmentLogic: 'Logic',
      segmentOutput: 'Output',
      steps: {
        baseSalary: {
          formula:
            'f(grade, job type) → base salary table → base salary amount',
          inputs: {
            grade: 'Grade',
            jobType: 'Job type',
            table: 'Base salary table',
          },
          link: 'Base salary',
          output: 'Base salary',
          title: 'Base salary',
        },
        commuting: {
          inputs: {
            route: 'Commute route',
            table: 'Commuting allowance table',
          },
          link: 'Non-taxable commuting allowance',
          output: 'Non-taxable commuting allowance',
          title: 'Non-taxable commuting allowance',
        },
        healthInsurance: {
          inputs: {
            gross: 'Gross pay (basis)',
            premiumTable: 'Premium table',
          },
          link: 'Health / nursing premiums',
          output: 'Health / nursing premiums',
          title: 'Health insurance / nursing care insurance',
        },
        overtimePay: {
          formula: 'Overtime rate × overtime hours × premium rate',
          inputs: {
            hours: 'Overtime hours',
            premium: 'Premium rate',
            rate: 'Overtime rate',
          },
          link: 'Overtime allowance',
          output: 'Overtime allowance',
          title: 'Overtime allowance',
        },
        overtimeUnit: {
          inputs: {
            grade: 'Grade',
            rateTable: 'Overtime rate table',
          },
          link: 'Overtime unit price',
          output: 'Overtime unit price',
          title: 'Overtime unit price',
        },
        paidBaseSalary: {
          formula:
            'Base salary − (base salary ÷ prescribed hours × absence hours)',
          inputs: {
            absence: 'Absence hours',
            base: 'Base salary',
            baseAgain: 'Base salary (again)',
            prescribedHours: 'Prescribed hours / month',
          },
          link: 'Paid base salary',
          output: 'Paid base salary',
          title: 'Paid base salary',
        },
        positionAllowance: {
          inputs: {
            amountTable: 'Position amount table',
            role: 'Role',
          },
          link: 'Position allowance',
          output: 'Position allowance',
          title: 'Position allowance',
        },
        totalEarnings: {
          inputs: {
            items: 'All earning items',
          },
          link: 'Gross pay',
          output: 'Gross pay',
          title: 'Total earnings',
        },
      },
    },
    tabs: {
      detail: 'Overview',
      dynamics: 'Dynamics',
      dynamicsV2: 'Dynamics v2',
      structure: 'Structure',
    },
  },
  tabs: {
    items: 'Payroll Items',
    logicComponents: 'Logic components',
    payrollStructures: 'Payroll structures',
    payrollUnits: 'Payroll units',
  },
};
